import React, { FC, useCallback } from 'react';
import { Box, IconButton, Modal } from '@mui/material';
import { EventTicketDto } from '@sweatpals/shared';
import { EventType } from '@/modules/_core/types/event-types';
import UpgradeTicketForm from './upgrade-ticket-form.component';
import Logo from '@/modules/_core/components/logo/logo.component';
import CloseIcon from '@mui/icons-material/CloseRounded';
import { useStyles } from '@sweatpals/react-ui-kit';
import { upgradeTicketFormModalStyles } from './upgrade-ticket-form-modal.styles';

export interface UpgradeTicketFormModalProps {
	open: boolean;
	ticket: EventTicketDto;
	eventData: EventType;
	freeSpotsCount?: number;

	onClose(): void;

	refetchOrder?(): Promise<unknown>;
}

const UpgradeTicketFormModal: FC<UpgradeTicketFormModalProps> = (props) => {
	const { open, ticket, eventData, onClose, refetchOrder } = props;
	const styles = useStyles(upgradeTicketFormModalStyles);

	const handleSubmit = useCallback(async (): Promise<void> => {
		await refetchOrder?.();
		onClose();
	}, [onClose, refetchOrder])

	return (
		<Modal open={open}>
			<UpgradeTicketForm
				ticket={ticket}
				eventData={eventData}
				onViewMyTickets={onClose}
				onWarningModalClose={onClose}
				onSubmit={handleSubmit}
				Header={({ isSubmitting }) => (
					<Box display="flex" justifyContent="space-between" alignItems="center">
						<Logo type="light" sx={{ cursor: 'default', height: '21px' }} layout="fill" />
						<IconButton sx={styles.closeIcon} disabled={isSubmitting} onClick={onClose}>
							<CloseIcon />
						</IconButton>
					</Box>
				)}
			/>
		</Modal>
	);
};

export default UpgradeTicketFormModal;
